<template>
  <footer>
    <span>©Winona {{ getYear }}</span>
    <ul>
      <li><router-link to="/contact-us">Contact Us</router-link></li>
      <li><a href="#" v-b-modal.terms>Terms &amp; Conditions</a></li>
    </ul>
    <b-modal
      id="terms"
      hide-footer
      size="lg"
      title="Terms &amp; Conditions"
      scrollable
    >
      <terms />
    </b-modal>
  </footer>
</template>

<script>
import Terms from "@/components/partials/Terms";
const year = new Date().getFullYear();
export default {
  name: "navbar-footer",
  components: {
    Terms,
  },
  data() {
    return {};
  },
  computed: {
    getYear() {
      return year;
    },
  },
};
</script>

<style scoped>
/***
*    ██████╗ ███████╗███████╗██████╗     ███████╗███████╗██╗     ███████╗ ██████╗████████╗ ██████╗ ██████╗
*    ██╔══██╗██╔════╝██╔════╝██╔══██╗    ██╔════╝██╔════╝██║     ██╔════╝██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗
*    ██║  ██║█████╗  █████╗  ██████╔╝    ███████╗█████╗  ██║     █████╗  ██║        ██║   ██║   ██║██████╔╝
*    ██║  ██║██╔══╝  ██╔══╝  ██╔═══╝     ╚════██║██╔══╝  ██║     ██╔══╝  ██║        ██║   ██║   ██║██╔══██╗
*    ██████╔╝███████╗███████╗██║         ███████║███████╗███████╗███████╗╚██████╗   ██║   ╚██████╔╝██║  ██║
*    ╚═════╝ ╚══════╝╚══════╝╚═╝         ╚══════╝╚══════╝╚══════╝╚══════╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝
Intended for breaking hierarchy rules using ">>>" or "/deep/" see link below,
without changing any custom css in other components
https://vue-loader.vuejs.org/guide/scoped-css.html
*/
/deep/.modal-header .close {
  margin-top: -0.75em;
}
</style>

<style lang="scss" scoped>
footer {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  padding: 0 70px;
  z-index: 200;
  background-color: $quaternary;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    > li {
      display: inline-block;
      margin: 0 10px;
    }
  }
}

@media (max-width: 991px) {
  footer {
    padding: 0 15px;
  }
}
</style>
